import { call, put, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/bank-accounts';
import api from '~/services/api';

function* loadBankAccounts({ partner }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/bank-accounts`
    );

    yield put(actions.loadBankAccountsSuccess(data.bank_account || {}));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* updateBankAccount({ partner, bank_accounting, data }) {
  try {
    yield call(
      api.put,
      `/v1/partners/${partner}/bank-accounts/${bank_accounting}`,
      data
    );

    yield put(actions.updateBankAccountSuccess());
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_BANK_ACCOUNTS, loadBankAccounts),
  takeLatest(Types.UPDATE_BANK_ACCOUNT, updateBankAccount)
];

export default sagas;
